import { useLocation, useNavigate, useParams } from "react-router-dom";

export function withRouterParams(Component) {
  return function WrappedComponent(props) {
    const params   = useParams();
    const navigate = useNavigate();
    const location = useLocation();           // <— avem și search, și pathname
    return (
      <Component
        {...props}
        params={params}
        navigate={navigate}
        location={location}
      />
    );
  };
}

